import { memo } from "react";
import { formattedDate, formattedDateTimeWithoutSec } from "../../../lib/functions";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";

interface RequestingDepartmentInformationProps {
    permitDetails: {
        s_ContractorEmployeeName: string;
        s_Nationality_En: string;
        s_NationalID: string;
        dt_NationalIDExpiryDate: any;
        dt_DateOfBirth: any;
        s_ContractorCompanyName: string;
        s_Department: string;
        s_JobPosition: string;
        dt_WorkStartDate: any;
        s_ResidentialAddress: string;
        s_ContactNumber: string;
        dt_CardValidityFrom: any;
        dt_CardValidityUntil: any;
    };
}

const RequestingDepartmentInformation = ({
    permitDetails,
}: RequestingDepartmentInformationProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 1: Requesting Department Information
                </span>
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Contractor/Employee Name:"
                    value={permitDetails?.s_ContractorEmployeeName || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Nationality:"
                    value={permitDetails?.s_Nationality_En || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="National ID:"
                    value={permitDetails?.s_NationalID || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="National ID Expiry Date:"
                    value={permitDetails?.dt_NationalIDExpiryDate ? formattedDate(new Date(permitDetails?.dt_NationalIDExpiryDate)) : ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Date of Birth:"
                    value={permitDetails?.dt_DateOfBirth ? formattedDate(new Date(permitDetails?.dt_DateOfBirth)) : ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Contractor's Company Name:"
                    value={permitDetails?.s_ContractorCompanyName || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Department:"
                    value={permitDetails?.s_Department || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Job Position:"
                    value={permitDetails?.s_JobPosition || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Work Start Date:"
                    value={permitDetails?.dt_WorkStartDate ? formattedDate(new Date(permitDetails?.dt_WorkStartDate)) : ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Contact Number:"
                    value={permitDetails?.s_ContactNumber || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Card Validity From:"
                    value={permitDetails?.dt_CardValidityFrom ? formattedDate(new Date(permitDetails?.dt_CardValidityFrom)) : ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Card Validity Until:"
                    value={permitDetails?.dt_CardValidityUntil ? formattedDate(new Date(permitDetails?.dt_CardValidityUntil)) : ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>
        </div>
    );
};

export default memo(RequestingDepartmentInformation);


